import { nextTick, ref } from 'vue'
import { Tabs } from '@/types/module'

export const useModuleFormValidation = () => {
	const formRef = ref<HTMLFormElement | null>(null)
	const activeTab = ref<Tabs>(Tabs.Module)

	const validateForm = async () => {
		const form = formRef.value
		if (!form) return false

		form.classList.add('was-validated')
		await nextTick()

		if (!form.checkValidity()) {
			const controls = Array.from(form.elements) as (HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement)[]
			const firstInvalid = controls.find((el) => !el.checkValidity())
			const tabPane = firstInvalid?.closest('[id$="-tab-pane"]')?.id

			activeTab.value = tabPane?.includes(Tabs.Measures) ? Tabs.Measures : Tabs.Module
			return false
		}

		return true
	}

	const triggerFormSubmit = () => {
		queueMicrotask(() => {
			formRef.value?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
		})
	}

	return { formRef, activeTab, validateForm, triggerFormSubmit }
}
